// extracted by mini-css-extract-plugin
module.exports = {"productContainer":"style_productContainer__bQWF_"};